import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default createReducer(initialState, {
  [c.GET_DOWNTIME_CATEGORIES_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_DOWNTIME_CATEGORIES_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.GET_DOWNTIME_CATEGORIES_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  })
});
